<template>
  <a-tabs type="card" defaultActiveKey="1">
    <a-tab-pane tab="Payout" key="1">
      <payout></payout>
    </a-tab-pane>
    <a-tab-pane tab="Income" key="2">
      <income></income>
    </a-tab-pane>
  </a-tabs>

</template>

<script>
import income from './income.vue'
import payout from './payout.vue'


export default {
  components: {
    income,
    payout
  },
  data() {
    return {
    }
  },
  mounted() {
  }
};
</script>
<style scoped></style>